import { ICustomer } from './customer.model';
import { Civility } from './enums/civility.enum';

export interface IContact {
  civility?: Civility;
  firstName?: string;
  lastName?: string;
  mail?: string;
  phone?: string;
  customer?: ICustomer;
}

export class Contact implements IContact {
  constructor(public civility?: Civility, public firstName?: string, public lastName?: string, public mail?: string, public phone?: string, public customer?: ICustomer) {}
}
